import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    AverageConsumedBalance : [],
    loading : false,
    error : null,
};

const AverageConsumedBalanceSlice = createSlice({
    name:"AverageConsumedBalance",
    initialState,
    reducers: {
        AverageConsumedBalanceSuccess: (state,action) => {
            state.loading = false;
            state.AverageConsumedBalance = action.payload
        },
        AverageConsumedBalanceFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    AverageConsumedBalanceSuccess,
    AverageConsumedBalanceFailure
} = AverageConsumedBalanceSlice.actions

export default AverageConsumedBalanceSlice.reducer